import * as fabric from 'office-ui-fabric-react';

export type WaitingTimesWarningType = 0 | 1;

interface IWaitingTimesWarningTypeEnum {
    WarningForService: WaitingTimesWarningType;
    WarningForLocationVisits: WaitingTimesWarningType;
    format(value: number): string | undefined;
    displayArray(): fabric.IDropdownOption[];
}

const datasource = () => [
    { key: 0, text: 'Įspėjimas paslaugai' },
    { key: 1, text: 'Įspėjimas padalinio vizitams' }
];

export const waitingTimesWarningType: IWaitingTimesWarningTypeEnum = {
    WarningForService: 0,
    WarningForLocationVisits: 1,
    format(value: number) {
        const item = datasource().find(x => x.key === value);
        return item && item.text;
    },
    displayArray() {
        let types : fabric.IDropdownOption[] = [];
        types.push(datasource()[0]);
        types.push(datasource()[1]);
        return types;
    }
};
